module.exports = __webpack_public_path__ + "static/media/visa-new-logo.386b4cb4.svg";